import { css } from 'styled-components/macro';

export default css`
    body {
        font-family: ${props => props.theme.body_font};
        font-size: 1.5rem;
        line-height: 1.4;
        color:  ${props => props.theme.body_color};
    }
    
    p {
        margin: 0;
    }

    button {
        font-family: ${props => props.theme.body_font};
        font-size: 1.5rem;
        line-height: 1.4;
    }
    
    :is(h1, h2, h3, h4, h5, h6),
    :is(.h1, .h2, .h3, .h4, .h5, .h6) {
        font-family: ${props => props.theme.heading_font};
        font-weight: 400;
        margin: 0;
    }
    
    :is(h1, .h1) {
        font-family: ${props => props.theme.deco_font};
        font-size: 6.4rem;
        line-height: 1;
    }
    
    :is(h2, .h2) {
        font-size: 5.2rem;
        line-height: 1;
    }
    
    :is(h3, .h3) {
        font-size: 4.6rem;
        line-height: 1.1;
        font-weight: 700;
    }
    
    :is(h4, .h4) {
        font-size: 3.2rem;
        line-height: 1.2;
    }
    
    :is(h5, .h5) {
        font-size: 2.4rem;
        line-height: 1.2;
        letter-spacing: .15em;
    }

    :is(h6, .h6) {
        font-size: 1.6rem;
        line-height: 1.25;
        font-weight: 700;
        letter-spacing: .2em;
        text-transform: uppercase;
    }

    .important {
        font-size: 1.8rem;
        line-height: 1.2;
        font-weight: 600;
        letter-spacing: .02em;
    }

    sup {
        font-size: 0.625em;
        vertical-align: text-top;
    }
    
    blockquote {
        padding-left: 1.6rem;
        border-left: 1px solid currentColor;
        color: ${props => props.theme.accent_color};
    }

    .content {
        > * + * {
            margin-top: 1.2rem;
        }
        
        > * + *:is(h1, h2, h3, h4, h5, h6) {
            margin-top: 2rem;
        }

        p:has(> img) + h6 {
            margin-top: 0;
        }
    }
`;
